<template>
  <div class="container">
    <div class="row justify-content-center mb-30">
      <span class="soha-forget-pass-title">
        {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
      </span>
    </div>
    <div class="row justify-content-center mb-10" v-if="step === 1">
      <h5>
        {{ $t(`${I18nPrefix}SEND_SMS_TEXT_PART_ONE`) }}
        <span class="font-weight-bolder px-1">{{
          toPersianDigits(username.value)
        }}</span>
        {{ $t(`${I18nPrefix}SEND_SMS_TEXT_PART_TWO`) }}
      </h5>
    </div>
    <div class="row justify-content-center mb-10" v-if="sendLinkMessage">
      <h5>
        {{ sendLinkMessage }}
      </h5>
    </div>
    <div class="row justify-content-center">
      <soha-text-field
        v-if="step === 0"
        class="w-400px"
        @onEnterPressed="checkUsername"
        name="username"
        v-model.trim="username.value"
        :error="username.error"
        :placeholder="$t(`${I18nPrefix}USERNAME_PLACEHOLDER`)"
      />
      <soha-text-field
        v-else
        class="w-400px"
        @onEnterPressed="checkCode()"
        name="code"
        v-model.trim="code.value"
        :error="code.error"
        :placeholder="$t(`${I18nPrefix}CODE`)"
      />
    </div>
    <div class="row m-0">
      <div class="w-400px mx-auto">
        <div
          :class="[
            'row mt-10 mx-0',
            step === 1 ? 'justify-content-between' : 'justify-content-end',
          ]"
        >
          <soha-button
            v-if="step === 1"
            name="continue"
            @click="checkCode"
            :loading="checkCodeBtnLoading"
            width="185"
            :text="$t(`${I18nPrefix}CONTINUE`)"
            class="mb-3"
          />
          <soha-button
            name="checkUsername"
            :disable="dismissCountDown > 0"
            @click="resendBtn && step === 1 ? resendSMS() : checkUsername()"
            :loading="btnLoading"
            width="185"
            :text="buttonText"
            class="mb-3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ValidationMixin from "@/mixins/ValidationMixin";
import ApiService from "@/core/services/api.service";

export default {
  mixins: [UIMixin, ValidationMixin],
  name: "ForgetPassword",
  data() {
    return {
      I18nPrefix: "PAGES.AUTH.FORGET_PASSWORD.",
      step: 0,
      username: {
        value: null,
        error: null,
      },
      code: {
        value: null,
        error: null,
      },
      sendLinkMessage: null,
      btnLoading: false,
      dismissSecs: 60,
      dismissCountDown: 0,
      resendBtn: false,
      checkCodeBtnLoading: false,
    };
  },
  methods: {
    checkUsername() {
      this.sendLinkMessage = null;
      this.username.error = this.validateUsername(this.username.value);
      if (this.username.error) return;
      this.btnLoading = true;
      ApiService.post("api/check_user", {
        username: this.username.value,
      })
        .then((data) => {
          if (data.data.status === "error") {
            this.errorToast(data.data.message);
          } else {
            this.dismissCountDown = this.dismissSecs;
            this.countDownTimer();
            this.resendBtn = true;
            if (data.data.status === "email") {
              this.sendLinkMessage = data.data.message;
              this.successToast(data.data.message);
            } else if (data.data.status === "sms") {
              this.step = data.data.step;
            }
          }
          this.btnLoading = false;
        })
        .catch((error) => {
          if (error.data.status == 400) {
            this.errorToast(this.$t(`${this.I18nPrefix}WRONG_PASSWORD`));
          } else {
            this.errorToast(this.$t(`${this.I18nPrefix}SERVER_ERROR`));
          }
          this.btnLoading = false;
        });
    },

    resendSMS() {
      this.btnLoading = true;
      ApiService.post("api/resend_sms", {
        username: this.username.value,
      })
        .then((data) => {
          if (data.data.status === "error") {
            this.errorToast(data.data.message);
          } else if (data.data.status === "ok") {
            this.dismissSecs = 99;
            this.dismissCountDown = this.dismissSecs;
            this.countDownTimer();
          }
          this.btnLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorToast(
              this.$t(`${this.I18nPrefix}RESTART_RESET_PASSWORD_ERROR`)
            );
          } else {
            this.errorToast(this.$t(`${this.I18nPrefix}SERVER_ERROR`));
          }
          this.btnLoading = false;
        });
    },

    checkCode() {
      this.code.error = this.validateField(
        this.code.value,
        this.$t(`${this.I18nPrefix}CODE`)
      );
      if (this.code.error) return;
      this.checkCodeBtnLoading = true;
      ApiService.post("api/check_sms", {
        username: this.username.value,
        code: this.code.value,
      })
        .then((data) => {
          if (data.data.status === "ok") {
            let params = this.$route.params.previousUrl?.includes("/inv/") && {
              previousUrl: this.$route.params.previousUrl,
            };
            this.$router.push({
              name: "reset-password",
              query: { token: data.data.remember_token },
              params: params,
            });
          } else if (data.data.status === "wrong_code") {
            this.errorToast(this.$t(`${this.I18nPrefix}WRONG_CODE`));
          }
          this.checkCodeBtnLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorToast(
              this.$t(`${this.I18nPrefix}RESTART_RESET_PASSWORD_ERROR`)
            );
          } else {
            this.errorToast(this.$t(`${this.I18nPrefix}SERVER_ERROR`));
          }
          this.checkCodeBtnLoading = false;
        });
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    countDownTimer() {
      if (this.dismissCountDown > 0) {
        setTimeout(() => {
          this.dismissCountDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
  },
  computed: {
    buttonText() {
      return this.resendBtn
        ? this.$t(`${this.I18nPrefix}RESEND`) +
            "  " +
            (this.dismissCountDown > 0
              ? this.toPersianDigits(this.dismissCountDown)
              : "")
        : this.$t(`${this.I18nPrefix}SEND`);
    },
  },
};
</script>

<style scoped>
.soha-forget-pass-title {
  font-size: 2.231rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.59;
  letter-spacing: normal;
  text-align: center;
  color: var(--primary-color);
}
</style>
